import { BFormFile } from './form-file';
import { pluginFactory } from '../../utils/plugins';
var FormFilePlugin = /*#__PURE__*/pluginFactory({
  components: {
    BFormFile: BFormFile,
    BFile: BFormFile
  }
});
export { FormFilePlugin, BFormFile };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/form-file/index.js
// module id = 469
// module chunks = 1